import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const CompanySettings = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Firma Ayarları
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>Firma ayarları burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default CompanySettings;
